import GroupsIcon from '@mui/icons-material/Groups'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import { routeFrontOfficeContracts } from '@/lib/routes/front/common/routeFrontOfficeContracts'
import { routeFrontOfficeInvoices } from '@/lib/routes/front/common/routeFrontOfficeInvoices'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

export const getFrontOfficeInsightPharmacien = [
  {
    route: 'TeamsList',
    text: 'Equipe officinale',
    t: 'routes.frontoffice.all.teamsList',
    icon: GroupsIcon,
    href: '/frontoffice/group/user-team/user-team-list',
    menuHeader: true,
    position: 120,
    isMobile: false,
  },
  {
    route: 'editUser',
    text: "Editer un membre de l'équipe",
    t: 'routes.frontoffice.all.teamUserEdit',
    href: '/frontoffice/group/user-team/edit-user-team/[userId]',
  },
  {
    route: 'TeamUserAdd',
    text: "Ajouter un membre de l'équipe",
    t: 'routes.frontoffice.all.teamUserAdd',
    href: '/frontoffice/group/user-team/add-user-team',
  },
  ...routeFrontOfficeContracts,
  ...routeFrontOfficeInvoices,
  {
    route: 'GuidesDocumentations',
    text: 'Guides & Documentations',
    t: 'routes.frontoffice.insight.documentation',
    icon: MenuBookIcon,
    href: '/frontoffice/group/documentation',
    menuHeader: true,
    position: 210,
  },
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDINSIGHT],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_INSIGHT_PHARMACIEN],
}))
